import React from "react";
import { Button, Icon, Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import { hasAccessRole, isCampaignFinished } from "../../../../../services/utils";
import UserRoleEnum from "../../../../../constants/UserRoleEnum";

const CampaignDetailHeader = ({
  campaign,
  mode,
  user,
  history,
  isPaused,
  onViewProposal,
  onCreateProposal,
  onGoToCMS,
  onViewReport,
  onOpenAudience,
  onEdit,
  canEdit,
  onTogglePause,
  onRelaunch,
  actionsDisabled,
}) => {
  const { t } = useTranslation();
  const isProposalMode = mode === "proposal";
  const paymentStatus = campaign && campaign.payment_status;
  const canGenerateProposal =
    user &&
    hasAccessRole(user.roles, [UserRoleEnum.agencyMember, UserRoleEnum.companyMember]);
  const crumbLabel = isProposalMode ? t("My proposals") : t("My campaigns");
  const crumbPath = isProposalMode ? "/proposals" : "/campaigns";

  return (
    <div className="campaignDetail__header">
      <nav className="campaignDetail__breadcrumb">
        <span
          className="campaignDetail__breadcrumb-link"
          onClick={() => history && history.push(crumbPath)}
        >
          {crumbLabel}
        </span>
        <span> / </span>
        <span>{campaign ? campaign.name : ""}</span>
      </nav>

      <div className="campaignDetail__actions">
        {isProposalMode ? (
          <Button onClick={onCreateProposal} disabled={actionsDisabled}>
            {t("Create proposal")} <Icon type="file-add" />
          </Button>
        ) : paymentStatus === "approved" ? (
          <Button onClick={onViewProposal} disabled={actionsDisabled}>
            {t("View proposal")} <Icon type="profile" />
          </Button>
        ) : paymentStatus === "pending" && canGenerateProposal ? (
          <Button onClick={onViewProposal} disabled={actionsDisabled}>
            {t("Proposal")} <Icon type="profile" />
          </Button>
        ) : null}
        <Button onClick={onGoToCMS} disabled={actionsDisabled}>
          {t("Go to CMS")} <Icon type="arrow-right" />
        </Button>
        <Button onClick={onViewReport} disabled={actionsDisabled}>
          {t("View report")} <Icon type="file-text" />
        </Button>
        <Button onClick={onOpenAudience} disabled={actionsDisabled}>
          {t("Audience")} <Icon type="eye" />
        </Button>
        <Tooltip
          title={
            !canEdit && campaign && campaign.company ? (
              <div>
                <div>
                  {t("Company")}: {campaign.company.name}
                </div>
                <div>
                  {t("The logged-in user is not the owner of this campaign")}
                </div>
              </div>
            ) : isProposalMode ? (
              t("Edit proposal")
            ) : (
              t("Edit campaign")
            )
          }
        >
          <Button onClick={onEdit} disabled={!canEdit || actionsDisabled}>
            {t("Edit")} <Icon type="edit" />
          </Button>
        </Tooltip>
        {campaign &&
        campaign.payment_status === "approved" &&
        campaign.status === "ready" &&
        !isCampaignFinished(campaign.end_date) ? (
          <Button onClick={onTogglePause} disabled={actionsDisabled}>
            {isPaused ? t("Activate campaign") : t("Pause campaign")}{" "}
            <Icon type={isPaused ? "play-circle" : "pause-circle"} />
          </Button>
        ) : null}
        <Button type="primary" onClick={onRelaunch} disabled={actionsDisabled}>
          {t("Relaunch")} <Icon type="redo" />
        </Button>
      </div>
    </div>
  );
};

export default CampaignDetailHeader;
